export default __webpack_public_path__ + "static/mk3-2d92aa77431ac3fb1f00fc8066852c78.png";